import * as actions from './actions'
import { success, failure } from 'utilities/actions'
import type { Action } from '../types'
import type { ReportAnalyticsMeasurandOption } from 'types'

export type State = {
  sampleNames?: string[];
  measurands?: ReportAnalyticsMeasurandOption[];
  errors: any[];
};

export const initialState = {
  sampleNames: undefined,
  measurands: undefined,
  errors: []
} as const

// @ts-expect-error - TS2322 - Type '{ readonly sampleNames: undefined; readonly measurands: undefined; readonly errors: readonly []; }' is not assignable to type 'State'.
const reducer = (state: State | null | undefined = initialState, action: Action) => {
  switch (action.type) {
    case actions.API_REPORTS_ANALYTICS_DETAILS_INDEX:
      return initialState
    case success(actions.API_REPORTS_ANALYTICS_DETAILS_INDEX):
// @ts-expect-error - TS2698 - Spread types may only be created from object types. - fall through
      return { ...initialState, ...action.data }
    case failure(actions.API_REPORTS_ANALYTICS_DETAILS_INDEX):
      return { ...initialState, errors: action.errors }
    default:
      return state
  }
}

export default reducer
